import { createRouter, createWebHistory } from 'vue-router';

// Import your components
import HomePage from '@/components/HomePage.vue';
import AboutUsPage from './components/AboutUsPage.vue';
import GalleryPage from './components/GalleryPage.vue';
import BlogPage from './components/BlogPage.vue';
import ContactUsPage from './components/ContactUsPage.vue';

const routes = [
  { path: '/', component: HomePage }, // Home Route
  { path: '/aboutus', component: AboutUsPage }, // AboutUsPage Us Route
  { path: '/gallery', component: GalleryPage }, // AboutUsPage Us Route
  { path: '/blog', component: BlogPage }, // Blog Us Route
  { path: '/contact', component: ContactUsPage }, // Contact Us Route
  
 
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;